import { AfterContentChecked, Component, ContentChildren, EventEmitter, Input, Output, QueryList } from '@angular/core';
import { ResponsiveDisplayConstants } from '@ddt-web/dom';

import { TabPanelComponent } from './tab-panel';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'bfa-tabs',
	templateUrl: './tabs.component.html',
	styleUrls: ['./tabs.component.scss']
})
export class TabsComponent implements AfterContentChecked {
	@Input('activate-on-mobile') public isActivatedOnMobile: boolean = false;
	@Input() public align: string = 'left';
	@Input('full-width') public hasFullWidth: boolean = false;
	@Input() public showTabNavSeparator: boolean = false;
	@Input() public hideTabBarIfOneTab: boolean = false;
	@Input() public type: string = 'button';
	// for toggle button skin, provide 'toggle-buttons' as part of custom-classes input
	@Input('custom-classes') public customClasses: string = '';
	@ContentChildren(TabPanelComponent) public tabs: QueryList<TabPanelComponent>;
	@Output() public activeTabPanelChange: EventEmitter<{ index: number; title: string }>
		= new EventEmitter<{ index: number; title: string }>();

	public activeTab: TabPanelComponent;
	public activeTabIndex: number;
	public numberOfTabs: number = 0;
	public tabMaxWidth: number = 0;

	public ngAfterContentChecked(): void {
		if (this.numberOfTabs !== this.tabs.toArray().length) {
			this.numberOfTabs = this.tabs.toArray().length;
			this.tabMaxWidth = Math.floor(100 / this.numberOfTabs);
			const selectedTab = this.tabs.toArray().find((tab: TabPanelComponent) => tab.isActive);
			this.activeTab = selectedTab ? selectedTab : this.tabs.first;
			this.activeTabIndex = this.tabs.toArray().indexOf(this.activeTab);
		}
	}

	public activateTab(tab: TabPanelComponent, event: Event): void {
		event.preventDefault();
		this.activeTab = tab;
		this.activeTabIndex = this.tabs.toArray().indexOf(this.activeTab);
		const emitObject = {
			index: this.activeTabIndex,
			title: this.activeTab?.title
		};
		this.activeTabPanelChange.emit(emitObject);
	}

	public isMobile(): boolean {
		return window.innerWidth <= ResponsiveDisplayConstants.DEVICE_WIDTH.MOBILE_MAX;
	}
}
